export default "/images/about.png?8f672015b8c375b6e7ebaeb8829e099a";